import React, { Suspense } from 'react';

import Spinner from '../components/Spinner/Spinner';

const Toolbar = React.lazy(() => import('../components/Toolbar/Toolbar'));
const Navigation = React.lazy(() => import('../components/Navigation/Navigation'));
const AlertsList = React.lazy(() => import('../components/Alerts/AlertsList/AlertsList'));

const withLayout = WrappedComponent => props => {

    const defaultStyle = { overflow: 'hidden' };

    return (
        <Suspense fallback={<Spinner text="Loading..." />}>
            <AlertsList />
            <div style={{ width: '100%', zIndex: '10' }}>
                <Toolbar />
                <Navigation />
            </div>
            <main className="content-main" style={defaultStyle}>
                <div className="content-wrapper">
                    <WrappedComponent {...props} />
                </div>
            </main>
        </Suspense>
    );
};

export const withLayoutAlt = WrappedComponent => props => {
    return (
        <Suspense fallback={<Spinner text="Loading..." />}>
            <AlertsList />
            <div style={{ width: '100%', zIndex: '10' }}>
                <Toolbar />
                <Navigation />
            </div>
            <main className="content-main" style={{ marginTop: '10px' }}>
                <div className="content-wrapper">
                    <WrappedComponent {...props} />
                </div>
            </main>
        </Suspense>
    );
};

export default withLayout;
